// @ts-expect-error any
window['global'] = {} // This fix is required for mapbox-gl-draw-circle
